import http from '@/api/http'
import { createApiError, parseApiResponse } from '@/api/parseApiResponse'

export async function adminRequest(request) {
  try {
    const response = await request()
    return parseApiResponse(response)
  } catch (error) {
    if (error?.response) {
      throw createApiError(error.response)
    }
    throw error
  }
}

export async function adminList(path, { limit = 100, skip = 0, filter = {}, sort = {} } = {}) {
  return adminRequest(() =>
    http.post(path, {
      limit,
      skip,
      filter,
      sort,
    }),
  )
}
